var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwomemberBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72002 17.794C5.47106 17.794 3.23446 17.794 0.9855 17.794C0.182301 17.794 0.0463746 17.6334 0.00930388 16.8178C-0.0771945 14.7419 0.429439 12.9007 1.94934 11.4055C3.17267 10.1945 4.6555 9.55198 6.37311 9.50255C7.21338 9.47784 8.06601 9.49019 8.90628 9.50255C12.5886 9.53962 15.3937 12.2829 15.4925 15.9652C15.5543 17.93 15.5419 17.8064 13.7131 17.8064C11.7113 17.7817 9.70948 17.794 7.72002 17.794Z",
    fill: "#178FFF",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8338 4.12727C11.8461 6.43801 10.005 8.29155 7.68186 8.29155C5.37112 8.29155 3.51758 6.43801 3.51758 4.13963C3.52994 1.86596 5.37112 0.0124188 7.64479 6.18364e-05C9.95553 -0.0122951 11.8214 1.82889 11.8338 4.12727Z",
    fill: "#178FFF",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6292 17.7936C16.7157 16.1007 16.7157 14.519 16.0731 13.0114C16.0237 12.8879 16.1596 12.6778 16.2214 12.5172C16.2461 12.4677 16.3202 12.4554 16.3697 12.4183C17.8031 11.578 21.5843 11.6028 22.993 12.4801C24.3152 13.308 24.9701 14.5313 24.9948 16.0883C25.0195 17.7936 25.0195 17.7936 23.3266 17.7936C21.3372 17.7936 19.3353 17.7936 17.3459 17.7936C17.1358 17.7936 16.9134 17.7936 16.6292 17.7936Z",
    fill: "#178FFF",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5826 10.6641C17.9515 10.6394 16.6416 9.30487 16.6664 7.68612C16.6911 6.01793 18.0256 4.74517 19.7062 4.76989C21.3496 4.80696 22.6347 6.10443 22.61 7.7479C22.5977 9.39137 21.2631 10.6888 19.5826 10.6641Z",
    fill: "#178FFF",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwomemberBlue);
export default __webpack_public_path__ + "static/media/twomemberBlue.5e4f2d8c9ad233c80667552f3ca44331.svg";
export { ForwardRef as ReactComponent };